import React from 'react';

import { useMutation } from '@apollo/client';
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Button, Grid, TextField } from '@mui/material';

import auth from '../../../../../services/Auth';
import signatureGQLSchemas from '../../../../../services/signatures/gqlSchema';
import AlreadySigned from './AlreadySigned';
import Pending from './Pending';

const Signed = ({ signature, contact, signerStatus }) => {
  const { iban, bic } = signature.sepaDetail;
  const [contactInfo] = auth.findContactsInfos({
    sources: {
      source: 'SALESFORCE',
      referer: 'INTRANET',
      section: 'CANDIDATE',
    },
  });

  const [deleteSepaSignature] = useMutation(signatureGQLSchemas.Mutation.deleteSepaSignature, {
    refetchQueries: [
      {
        query: signatureGQLSchemas.Query.signaturesByContact,
        variables: {
          contactId: contact.id,
          type: 'CANDIDATE',
        },
      },
    ],
  });

  const deleteSepa = async s => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce mandat SEPA ?')) {
      await deleteSepaSignature({
        variables: {
          id: signature.id,
          category: 'SEPA_CANDIDATE',
          isCandidate: true,
        },
      });
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          label='IBAN (International Bank Account Number)'
          id='ibanInput'
          name='iban'
          type='text'
          variant='outlined'
          fullWidth
          size='small'
          defaultValue={iban}
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='BIC (Bank Identifier Code)'
          id='BIC'
          variant='outlined'
          fullWidth
          size='small'
          defaultValue={bic}
          InputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      {signerStatus === 'ready' ? (
        <Pending signature={signature} contactId={contact.id} />
      ) : (
        <AlreadySigned signUuid={signature.signUuid} contactInfoId={contactInfo.id} contact={contact} />
      )}
      <Grid item xs={12}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            color='primary'
            variant='contained'
            onClick={() => {
              deleteSepa(signature);
            }}
          >
            <FontAwesomeIcon icon={faTrashCan} />
            <Box component='span' sx={{ marginLeft: '5px' }}>
              Supprimer ce mandat
            </Box>
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default React.memo(Signed);
